import React from "react";

function Historico({ historico, onLimpar }) {
  if (!historico || historico.length === 0) {
    return (
      <div className="historico">
        <h3>Histórico de cálculos</h3>
        <p>Nenhum cálculo realizado ainda.</p>
      </div>
    );
  }

  return (
    <div className="historico">
      <h3>Histórico de cálculos</h3>
      <table>
        <thead>
          <tr className="cabecalho-tabela">
            <th>IMC</th>
            <th>Data</th>
            <th>Hora</th>
          </tr>
        </thead>
        <tbody>
          {historico.map((item, index) => (
            <tr key={index}>
              <td>{item.valor}</td>
              <td>{item.data}</td>
              <td>{item.hora}</td>
            </tr>
          ))}
        </tbody>
      </table>
      <button onClick={onLimpar} className="btn-limpar">
        Limpar histórico
      </button>
    </div>
  );
}

export default Historico;